// extracted by mini-css-extract-plugin
export var content = "journal-module--content--11a06";
export var copy = "journal-module--copy--ce771";
export var copy_body = "journal-module--copy_body--fe4c5";
export var copy_cta = "journal-module--copy_cta--d8f3e";
export var himage = "journal-module--himage--c9a1a";
export var htitle = "journal-module--htitle--0e3fe";
export var image = "journal-module--image--c3a68";
export var jour_right = "journal-module--jour_right--b6046";
export var nd_journ = "journal-module--nd_journ--bd9c5";